import { useState, useEffect, useRef } from 'react';

// Универсальный автокомплит с debounce. fetchOptions(query) должен вернуть
// массив объектов вида { id, label }.
export default function SearchSelect({ value, onChange, onSelect, fetchOptions, placeholder, minChars = 1 }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const handleInput = (e) => {
    const q = e.target.value;
    onChange(q);
    setOpen(true);
    clearTimeout(timer.current);
    if (q.trim().length < minChars) {
      setOptions([]);
      return;
    }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetchOptions(q.trim());
        setOptions(res || []);
      } finally {
        setLoading(false);
      }
    }, 250);
  };

  const pick = (opt) => {
    onSelect(opt);
    setOpen(false);
  };

  return (
    <div className="search-select" ref={boxRef}>
      <input
        value={value}
        onChange={handleInput}
        onFocus={() => value.trim().length >= minChars && setOpen(true)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && (
        <div className="search-select-list">
          {loading && <div className="search-select-empty">Поиск...</div>}
          {!loading && options.length === 0 && value.trim().length >= minChars && (
            <div className="search-select-empty">Ничего не найдено</div>
          )}
          {!loading && options.map(opt => (
            <div key={opt.id} className="search-select-item" onClick={() => pick(opt)}>
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
